module.exports = __webpack_public_path__ + "static/img/20007 (6).ade3d3e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20007 (6).webp
// module id = 5wNj
// module chunks = 14